var React = require('react');

function SignatureIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2F3642","d":"M14,5 L11,7 L7,7 L7,17 L17,17 L17,13 L19,10 L19,17 C19,18.1045695 18.1045695,19 17,19 L7,19 C5.8954305,19 5,18.1045695 5,17 L5,7 C5,5.8954305 5.8954305,5 7,5 L14,5 Z M19.5,4.5 C19.7846508,4.78465076 19.8097492,5.23781346 19.5582739,5.55215763 L13.3251783,13.3435271 C12.9484117,13.8144854 12.3930855,14.0584837 11.8334418,14.0561618 L9,15 L9.94392938,12.1694336 C9.94085291,11.6795295 10.1262098,11.1886618 10.5,10.8148716 C10.5495341,10.7653375 10.6017716,10.7185827 10.6564729,10.6748217 L18.4478424,4.4417261 C18.7621865,4.19025076 19.2153492,4.21534924 19.5,4.5 Z"}));
}

SignatureIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SignatureIcon;

SignatureIcon.default = SignatureIcon;
